import type { SearchMode, SearchType } from 'cpool-constants';
import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { LoanRequestsTableDefinitionZod } from '../tables';
import { schemaUserResolver_GetAclPermissions } from '../../user/resolvers/getAclPermissions';

type Arguments = {
    filter: boolean;
    query: string;
    searchFields: Record<string, string>;
    searchMode: SearchMode;
    searchType: SearchType;
    limit?: number | string;
    offset?: number | string;
};

export const schemaLoanRequestResolver_Find = z.array(
    LoanRequestsTableDefinitionZod.merge(
        z.object({
            permissions: schemaUserResolver_GetAclPermissions,
            schufaSummary: z.object({ schufaScore: z.string().optional() }).nullable().optional(),
        }),
    ),
);

export type SchemaLoanRequestResolver_Find = z.infer<typeof schemaLoanRequestResolver_Find>;

export type LoanRequestResolver_Find = Resolver<Arguments, SchemaLoanRequestResolver_Find>;
